/**
 * Landing page assets and demonstration content.
 *
 * Everything in this file is either a visual asset or clearly marked
 * DEMONSTRATION content used to show what a surface looks like. No figure
 * here is presented on the page as a real platform total, and no institution
 * is presented as a partner. Campus availability is read from the campus
 * register, never from this file.
 */

export const landingImages = {
  /** Cut-out student photograph anchored to the hero composition. */
  heroStudent:
    'https://cdn.magicpatterns.com/patterns/generated-images/b2930caf-fb7f-4874-8f00-d4542df8135c.jpg',
  /** Campus environment sitting behind the hero product preview. */
  heroCampus:
    'https://cdn.magicpatterns.com/patterns/generated-images/8faec984-24d9-46f2-9a6b-5cdbdb59a147.jpg',
  academics:
    'https://cdn.magicpatterns.com/patterns/generated-images/40f097ff-764b-4639-9703-83bcddfd5ac4.jpg',
  marketplace:
    'https://cdn.magicpatterns.com/patterns/generated-images/479fbc8d-e0ee-4004-a9cd-bcb42409d164.jpg',
  housing:
    'https://cdn.magicpatterns.com/patterns/generated-images/af089e64-a391-40bc-a3c6-1c0731e8893c.jpg',
  campus:
    'https://cdn.magicpatterns.com/patterns/generated-images/658763ef-0d3b-408c-9198-375bf7a1c447.jpg',
  personalization:
    'https://cdn.magicpatterns.com/patterns/generated-images/384a3ae7-1e2b-4883-905e-7bf2631a16fa.jpg',
  ctaStudents:
    'https://cdn.magicpatterns.com/patterns/generated-images/c771da57-d88b-47a4-bff7-8576147b01a4.jpg',
  identityPortrait:
    'https://cdn.magicpatterns.com/patterns/generated-images/b2b3f6e0-ca08-443f-bc04-e179b567d43d.jpg',
  campusBuilding:
    'https://cdn.magicpatterns.com/patterns/generated-images/544f1d6d-665f-4c86-9e58-dd137cd60d5e.jpg',
} as const

/** Campus photography keyed by the register's campus id. */
export const campusPhotos: Record<string, string> = {
  'cmp-unilag': landingImages.campusBuilding,
  'cmp-futa': landingImages.campus,
  'cmp-oau': landingImages.heroCampus,
}

/**
 * DEMONSTRATION identity used in the hero preview and the identity banner.
 * It is the same demonstration student the signed-in product uses, so the
 * public page and the application show one person rather than two.
 */
export const demoIdentity = {
  name: 'Amarachi Obi',
  institution: 'UNILAG',
  campus: 'Akoka Campus',
  programme: 'B.Sc. Systems Engineering',
  level: '300 Level',
  photo: landingImages.identityPortrait,
} as const

/** DEMONSTRATION recommendations shown in the personalization section. */
export const demoProgrammeSignals = [
  { label: 'Recommended textbooks', note: 'Matched to MEE 302 and SYE 305' },
  { label: 'Engineering tutors', note: 'Rated by students who completed a session' },
  { label: 'Project opportunities', note: 'Open to 300 level and above' },
  { label: 'Engineering events', note: 'Published by your faculty' },
] as const

export const demoCampusSignals = [
  { label: 'Nearby housing options', note: 'Within 3 km of the main gate' },
  { label: 'Campus events', note: 'Published by clubs you follow' },
  { label: 'Food around campus', note: 'Vendors currently open' },
  { label: 'Campus services', note: 'Offered by your institution' },
] as const
